import React, { FC } from 'react'

import { ChipFilterView } from './ChipFilterView'
import { useChipContent } from '../hooks/useChipFilter'
import { TChipFilter } from '../types/ChipFilter.types'

export const ChipFilter: FC<TChipFilter> = ({ options, selectedOption, onFilter }) => {
  const { content } = useChipContent({ firstChip: selectedOption ?? options[0], onFilter })

  return (
    <ChipFilterView
      onClick={content.onClick}
      selectedChip={content.selectedChip}
      options={options}
    />
  )
}
